import { Routes } from '@angular/router';

import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';

import { authenticationGuard } from '@app/core/guards/authentication-guard';
import { PublicShellComponent } from '@app/shell/public-shell/public-shell.component';
import { PrivateShellComponent } from '@app/shell/private-shell/private-shell.component';
import privateRoutes from '@app/shell/private-shell/private-routes';
import { VitrineComponent } from './public/vitrine/vitrine.component';
import { AboutUsComponent } from './public/about-us.component';
import { HowItWorksMarketplaceComponent } from './public/how-it-works-marketplace/how-it-works-marketplace.component';
import { LegalNoticeComponent } from './public/legal-notice/legal-notice.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./public/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'reset-password',
    pathMatch: 'full',
    loadComponent: () =>
      import('./public/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'reset-password-request',
    pathMatch: 'full',
    loadComponent: () =>
      import('./public/reset-password-form/reset-password-form.component').then(
        (m) => m.ResetPasswordFormComponent
      ),
  },
  {
    path: 'confirm-account',
    loadComponent: () =>
      import('./public/confirm-account/confirm-account.component').then(
        (m) => m.ConfirmAccountComponent
      ),
  },
  {
    path: 'dashboard',
    component: PrivateShellComponent,
    canActivate: [authenticationGuard],
    children: privateRoutes,
  },
  {
    path: '',
    component: PublicShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'show' },
      {
        path: 'show',
        component: VitrineComponent,
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('./public/contact-us/contact-us.component').then(
            (m) => m.ContactUsComponent
          ),
      },
      {
        path: 'create-account',
        loadComponent: () =>
          import('./public/create-account/create-account.component').then(
            (m) => m.CreateAccountComponent
          ),
      },
    ],
  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'delete-account', component: DeleteAccountComponent },
  {
    path: 'cookies',
    loadComponent: () =>
      import('./public/cookies.component').then((m) => m.CookiesComponent),
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
  },
  {
    path: 'how-it-works-marketplace',
    component: HowItWorksMarketplaceComponent,
  },
  {
    path: 'legal-notice',
    component: LegalNoticeComponent,
  },
  { path: '', redirectTo: 'zero-waste', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];
